import React from 'react';
import {Button, Checkbox, Form, Icon, Input, message, Select, Tooltip} from 'antd';
import PropTypes from 'prop-types';
import {createDebounce, sanitizeFieldName} from '../../util/methods';
import DocumentList from "../AssetStockDocumentList";
import InlineCreateMasterModal from "../InlineCreateMasterModal";
import QrLinker from "../../containers/AssetStockTaking/QrLinker";
import Linker from "../../containers/AssetLink/Linker";

const {TextArea} = Input;

class SubList extends React.Component {

  id = 0;

  state = {
    keys: [], documentData: {}, manual: false, manualAssetCode: '', manualAssetData: null, linkVisible: false, createdConditions: []
  };

  componentDidMount() {
    const {data = [{}]} = this.props;
    this.setState({
      keys: data, manual: false,
    });
  }

  clearDocumentData() {
    this.setState({documentData: {}});
  }

  getDocumentData = (index, data) => {
    this.props.form.setFieldsValue({[`assetDetails[${index}][fileData]`]: data});
    this.setState({documentData: data});
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }

    if (nextProps && nextProps.assetFromCode && JSON.stringify(nextProps.assetFromCode) !== JSON.stringify(this.props.assetFromCode)) {
      const {assetCode, data} = nextProps.assetFromCode;
      // console.log(nextProps.assetFromCode);
      if (assetCode && data) {
        this.setState({
          manualAssetData: data,
          manualAssetCode: assetCode,
          linkVisible: true,
        });
      } else if (assetCode && !data) {
        this.setState({
          manualAssetData: null,
          manualAssetCode: '',
          linkVisible: false
        });
        message.error(`${assetCode} is a invalid Asset Code!`)
      }
    }
  }

  setManualAssetCode = createDebounce((val) => {
    if (val.length && val.split('-').length > 1) {
      this.setState({
        manualAssetCode: val
      })
    }
  }, 300);

  enableManualEntry = (index) => {
    this.setState({
      manual: !this.state.manual,
      manualAssetCode: '',
      manualAssetData: null,
      linkVisible: false
    }, () => {
      this.props.form.setFieldsValue({[`assetDetails[${index}][assetCode]`]: ''});
      this.props.form.setFieldsValue({[`assetDetails[${index}]['qr']`]: ''});
      this.props.handleDisableQRCode(this.state.manual);
      // this.props.resetSubData();
      this.props.resetScannedAssetData();
    });
  }

  pasteFromClipBoard = (event) => {
    try {
      navigator.clipboard.readText().then(data => {
        let parameters = data;
        let search = parameters.split('?')[1];
        parameters = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
        const assetCode = parameters.assetCode || '';
        this.props.onPaste && this.props.onPaste(assetCode);
      });
    } catch (e) {
      console.log(`Paste error`, e);
      message.error(`Unable to paste from clipboard!`)
    }
  }

  handleManualQrId = createDebounce((val) => {
    // console.log(val)
    if (val.length === 10) {
      this.props.setManualQr(val);
      this.props.getAssetByQr(val)
    } else {
      this.props.form.setFieldsValue({
        [`assetDetails[${this.props.form.getFieldValue('assetDetails').length - 1}][assetCode]`]: '',
      });
    }
  }, 300)

  linkQrWithAsset = (assetData) => {
    // console.log(assetData)
    if (assetData)
      this.props.getAssetByCode(assetData.toUpperCase());
  }

  linkToggleVisible = () => {
    this.setState((prevState) => {
      return {linkVisible: !prevState.linkVisible}
    });
  }

  mergeUniqueOptions = (baseOptions = [], createdOptions = []) => {
    const merged = [...(baseOptions || [])];
    (createdOptions || []).forEach((created) => {
      if (!created || !created._id) {
        return;
      }
      const exists = merged.find((item) => `${item && item._id}` === `${created._id}`);
      if (!exists) {
        merged.push(created);
      }
    });
    return merged;
  };

  getConditionOptions = () => {
    const schema = this.props && this.props.item && this.props.item.schema && this.props.item.schema.condition;
    const baseOptions = schema && schema.data && schema.data.data || [];
    return this.mergeUniqueOptions(baseOptions, this.state.createdConditions);
  };

  handleConditionCreated = (index, createdCondition) => {
    if (!createdCondition || !createdCondition._id) {
      return;
    }
    this.setState((prevState) => {
      const exists = (prevState.createdConditions || []).find((item) => `${item._id}` === `${createdCondition._id}`);
      if (exists) {
        return null;
      }
      return {
        createdConditions: [...(prevState.createdConditions || []), createdCondition],
      };
    });
    const fieldName = this.props && this.props.item && this.props.item.schema && this.props.item.schema.condition && this.props.item.schema.condition.field || 'condition';
    this.props.form.setFieldsValue({
      [`assetDetails[${index}][${fieldName}]`]: createdCondition._id,
    });
  };

  render() {
    const {
      form,
      item,
      data = [],
      resource,
      title,
      superMaster,
      subMaster,
      subDocumentFilters,
      linkRecordCode,
      assetData,
      scannedAssetData,
      resetScannedAssetData
    } = this.props;
    const {field} = item;
    const {getFieldDecorator, setFieldsValue} = form;
    const {keys, manual} = this.state;
    const conditionOptions = this.getConditionOptions();
    const manualPatternCheck = /^[A-Za-z0-9]{3}-[0-9]+$/; // /^[A-Za-z]+-[0-9]+?$/;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between'
    };
    // console.log(assetData, scannedAssetData)

    const formItems = keys.map((k, index) => {
      // const assetCode = this.props.assetData && JSON.stringify(this.props.assetData) !== '[{}]' && this.props.assetData.length && this.props.assetData[0] && this.props.assetData[0]['assetCode'];
      const assetCode = this.props.scannedAssetData &&  this.props.scannedAssetData.data && this.props.scannedAssetData.data['assetCode'];
      // console.log(assetCode)
      // const isQrExist = this.state.manualAssetData && this.state.manualAssetData.scannerData && this.state.manualAssetData.scannerData.length;
      return (<div key={index} style={style}>

        <div style={{width: '50%'}}>
          <Form.Item key={'assetCode'} className={'asset-code-form'}
                     label={<span>Asset Code&nbsp;
                       {this.props.isOldQr ? (<Tooltip title={'QR attached is OLD one'}>
                         <Icon type="warning" style={{color: 'red'}}/>
                       </Tooltip>) : null}
                          </span>}>
            {getFieldDecorator(`${field}[${index}][${item.schema['assetCode'].field}]`, {
              rules: [{
                required: item.schema['assetCode'].required,
                message: `${sanitizeFieldName(item.schema['assetCode'].options.label ? item.schema['assetCode'].options.label : item.schema['assetCode'].field)} is required!`
              }, {
                pattern: manual ? new RegExp(manualPatternCheck) : new RegExp(/.*/i), // pattern: new RegExp("[A-Z].*|[a-z].*  -[0-9].*"),
                message: "Invalid asset code. The format for asset code is Asset Sub Type Code - Asset Code Number - Eg TLY-001, without any space or special characters"
              }], initialValue: (data && data[index] ? data[index]['assetCode'] : ''),
            })(<Input disabled={!manual} style={{marginRight: 8}}
                      onChange={(e) => this.setManualAssetCode(e.target.value)}
                      placeholder={'Scan Qr or Enter Manually'} autoComplete='off'/>)}
          </Form.Item>
        </div>
        <div style={{width: '50%'}}>
          <Form.Item key={'qrId'} className={'asset-code-form'}
                     label={`OR QR Id`}>
            {getFieldDecorator(`${field}[${index}]['qrId']`, {
              initialValue: (data && data[index] ? data[index]['qrId'] : ''),
            })(<Input onChange={(e) => this.handleManualQrId(e.target.value)} disabled={!manual}
                      style={{marginRight: 8}}
                      placeholder={'Scan Qr or Enter Manually'}/>)}
          </Form.Item>
        </div>
        <div style={{
          width: '100%',
          display: "flex",
          flexDirection: `${this.props.width > 500 ? 'row' : 'column'}`,
          justifyContent: 'start'
        }}>
          {/*<Button type={'primary'} onClick={() => this.pasteFromClipBoard()}>Paste from Clipboard</Button>*/}
          <Button type={assetCode ? 'danger' : 'primary'} disabled={!(manual || assetCode)}
                  onClick={() => this.linkQrWithAsset(this.state.manualAssetCode || assetCode)}>{assetCode ? 'Update QR ' : 'Link QR'}</Button>
          <Form.Item key={'manual'} className={'manual-form'}
                     label={'Enter Asset/QR ID manually'}>
            {getFieldDecorator(`${field}[${index}][${item.schema['manual'].field}]`, {
              rules: [{
                required: item.schema['manual'].required,
                message: `${item.schema['manual'].options.label ? item.schema['manual'].options.label : item.schema['manual'].field} is required!`
              }],
              valuePropName: 'checked',
              initialValue: (data && data[index] ? !!data[index]['manual'] : manual),
            })(<Checkbox onClick={this.enableManualEntry.bind(this, index)}/>)}
          </Form.Item>

          <Form.Item key={'invalid-qr'} className={'manual-form'}
                     label={sanitizeFieldName(item.schema['isQrMismatched'].options.label ? item.schema['isQrMismatched'].options.label : item.schema['isQrMismatched'].field)}>
            {getFieldDecorator(`${field}[${index}][${item.schema['isQrMismatched'].field}]`, {
              rules: [{
                required: item.schema['isQrMismatched'].required,
                message: `${item.schema['isQrMismatched'].options.label ? item.schema['isQrMismatched'].options.label : item.schema['isQrMismatched'].field} is required!`
              }],
              valuePropName: 'checked',
              initialValue: (data && data[index] ? !!data[index]['isQrMismatched'] : false),
            })(<Checkbox/>)}
          </Form.Item>
        </div>
        <Form.Item key={'link-id'} className={'manual-form'}
                   label={'Link Id'} style={{display: linkRecordCode ? 'block' : 'none', width: '30%'}}>
          {getFieldDecorator(`${field}[${index}][${item.schema['link_record'].field}]`, {
            rules: [],
            initialValue: (data && data[index] && data[index]['link_record'] || ''),
          })(<Input disabled style={{width: '70%'}}/>)}
        </Form.Item>
        <Form.Item></Form.Item>
        <Form.Item key={'condition'}
                   label={sanitizeFieldName(item.schema['condition'].options.label ? item.schema['condition'].options.label : item.schema['condition'].field)}
                   style={{width: '100%'}}>
          {getFieldDecorator(`${field}[${index}][${item.schema['condition'].field}]`, {
            rules: [{
              required: item.schema['condition'].required,
              message: `${sanitizeFieldName(item.schema['condition'].options.label ? item.schema['condition'].options.label : item.schema['condition'].field)} is required!`
            }], initialValue: (data && data[index] ? data[index]['condition'] : ''),
          })(<Select
            showSearch
            style={{width: '80%'}}
            placeholder="Please select"
            filterOption={(input, option) => (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0}
            disabled={(title === 'EDIT' && item.schema['condition'] && item.schema['condition'].options.disabledOnEdit) || false}
          >
            {(conditionOptions || []).map(itm =>
              <Select.Option key={itm._id} value={itm._id}>{itm.name}</Select.Option>)}
          </Select>)}
          {item.schema['condition'] && item.schema['condition'].options && item.schema['condition'].options.master ?
            <InlineCreateMasterModal
              item={item.schema['condition'].options.ref}
              onCreated={(createdCondition) => this.handleConditionCreated(index, createdCondition)}
              triggerStyle={{
                margin: '0',
                marginTop: '0',
                marginLeft: '10px',
                width: 'calc(100% - 10px)'
              }}
            /> : ''}
        </Form.Item>

        <Form.Item key={'remarks'}
                   label={sanitizeFieldName(item.schema['remarks'].options.label ? item.schema['remarks'].options.label : item.schema['remarks'].field)}>
          {getFieldDecorator(`${field}[${index}][${item.schema['remarks'].field}]`, {
            rules: [{
              required: item.schema['remarks'].required,
              message: `${sanitizeFieldName(item.schema['remarks'].options.label ? item.schema['remarks'].options.label : item.schema['remarks'].field)} is required!`
            }], initialValue: (data && data[index] ? data[index]['remarks'] : ''),
          })(<TextArea style={{marginRight: 8}}
                       placeholder={sanitizeFieldName(item.schema['remarks'].options.label ? item.schema['remarks'].options.label : item.schema['remarks'].field)}/>)}
        </Form.Item>

        <Form.Item style={{display: 'none'}}>
          {getFieldDecorator(`${field}[${index}][fileData]`, {
            rules: false, message: '', initialValue: '',
          })(<Input style={{display: 'none'}}/>)}
        </Form.Item>

        {(data && data[index] && data[index].photos) ? <div className='document-upload'>
          <div>Photos</div>
          {data[index].photos.map(item => {
            return <a style={{display: 'block'}} key={item.url} href={`${item.url}`}
                      target='_blank'>{item.name}</a>
          })}
        </div> : <DocumentList match={this.props.match} history={this.props.history}
                               documentData={this.state.documentData}
                               key={index} item={item.schema['photos']} form={form}
                               data={data[index] && data[index].photos}
                               getDocumentData={this.getDocumentData.bind(this, index)}/>

        }
      </div>)
    });

    return (<div className='stock-taking-sublist'>
      {formItems}
      {this.state.manualAssetData && this.state.linkVisible && (
        <Linker asset={this.state.manualAssetData} linkType={'QR'} createLink={this.props.createLink}
                coords={this.props.coords}
                toggleView={this.linkToggleVisible}
                isVisible={this.state.linkVisible} match={this.props.match} history={this.props.history}
                form={this.props.form}
                qrUsed={this.props.qrUsed}
                loading={this.props.loading}
                linkStatus={this.props.linkStatus}
                checkQrAlreadyUsed={this.props.checkQrAlreadyUsed} allTagTypes={this.props.allTagTypes}
                getAllTagTypes={this.props.getAllTagTypes}/>
      )}
      <br/>

    </div>);
  }
}

export default SubList;
SubList.defaultProps = {};

SubList.propTypes = {
  item: PropTypes.object,
};
